import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api from "../lib/api";
import { formatApiError } from "../lib/format";
import { Mail, ArrowLeft } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/password-reset/request", { email });
      setSent(true);
      toast.success("If the email exists, a reset link has been sent.");
    } catch (err) {
      toast.error(formatApiError(err));
    }
  };
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F7F9F8] p-6">
      <div className="card-modav p-8 w-full max-w-md" data-testid="forgot-password-card">
        <h2 className="font-serif text-2xl font-bold text-[#1A2E24]">Reset your password</h2>
        <p className="text-sm text-[#5E7166] mt-1">Enter your email and we'll send you a reset link.</p>
        {sent ? (
          <div className="mt-6 p-4 rounded-lg bg-[#E8F5EE] text-[#0E5C3A] text-sm">
            If an account exists for <b>{email}</b>, a reset link has been generated. Check the backend logs for the token (mock email).
          </div>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4" data-testid="forgot-password-form">
            <div className="relative">
              <Mail size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#5E7166]"/>
              <input type="email" required value={email} onChange={e=>setEmail(e.target.value)} className="input-modav pl-10" placeholder="you@modavhomes.ng" data-testid="forgot-email"/>
            </div>
            <button type="submit" className="btn-gold w-full justify-center" data-testid="forgot-submit">Send Reset Link</button>
          </form>
        )}
        <Link to="/login" className="mt-4 inline-flex items-center gap-1 text-sm text-[#0E5C3A]"><ArrowLeft size={14}/> Back to login</Link>
      </div>
    </div>
  );
}
